/**
 * @fileoverview GET handler for the "/app_settings/test_user_logs/search_terms" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsTestUserLogsSearchTerms } from "./constants";
import type { AppSettingsTestUserLogsSearchTermsResult } from "./types";
import { isAppSettingsTestUserLogsSearchTermsResult } from "./validators";

export const getAppSettingsTestUserLogsSearchTerms = reactQueryFetcherAdapter(
  appSettingsTestUserLogsSearchTerms,
  (signal: AbortSignal, appGroupId: string): Promise<AppSettingsTestUserLogsSearchTermsResult> => {
    return fetch("/app_settings/test_user_logs/search_terms", "GET", { app_group_id: appGroupId }, { signal });
  },
  isAppSettingsTestUserLogsSearchTermsResult
);
